import { z } from 'zod';
import { timeTrackingEntryResponseSchema } from './time-entry.schema';

/** Ein meistgenutztes Projekt (Dashboard-Aggregat; echtes oder Zeit-Projekt). */
export const topProjectSchema = z.object({
  projectName: z.string(),
  legalEntityName: z.string().nullable(),
  hours: z.number(),
});
export type TopProject = z.infer<typeof topProjectSchema>;

/** Dashboard-Aggregat des angemeldeten Mitarbeiters. */
export const timeTrackingDashboardSchema = z.object({
  hoursToday: z.number(),
  hoursThisWeek: z.number(),
  activeProjectCount: z.number().int(),
  hasRunningTimer: z.boolean(),
  runningTimer: timeTrackingEntryResponseSchema.nullable(),
  mostUsedProjects: z.array(topProjectSchema),
  recentEntries: z.array(timeTrackingEntryResponseSchema),
});
export type TimeTrackingDashboard = z.infer<typeof timeTrackingDashboardSchema>;
